/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';

import { OperationsLogger, VuLogger } from '../../../../core/logging';
import { Log } from '../../../../core/logging/Log';
import { ScreenControllerTypes } from '../../../../core/navigation/ScreenControllerTypes';
import { ScreenTaskControllerTypes } from '../../../../core/navigation/ScreenTaskControllerTypes';
import { OverlayTypes } from '../../../overlay/OverlayTypes';
import {
    hideOverlayDialog,
    showOverlayDialog,
} from '../../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../../screens/screens.reducers';

const TAG = 'VideoPlayerErrorOverlay';

export const showErrorOverlay =
    (errorOverlayData: IOverlayDialog) => (dispatch: Function, getState: Function) => {
        const { isErrorOSDActive } = getState().errorOsd;
        const { screenController } = getState().screens;
        const { isOverlayDialogActive, uiProperties: uiProps } = getState().overlayDialog;
        if (screenController === ScreenControllerTypes.VIDEO_PLAYER && !isErrorOSDActive) {
            if (
                !isOverlayDialogActive ||
                (errorOverlayData.errorPriority &&
                    errorOverlayData.errorPriority > uiProps.errorPriority)
            ) {
                Log.d(
                    TAG,
                    'showErrorOverlay {screenTaskController: ',
                    ScreenTaskControllerTypes.PLAYER_ERROR_OVERLAY,
                    '}',
                );
                Diagnostics.debug(
                    TAG,
                    'showErrorOverlay {screenTaskController: ',
                    ScreenTaskControllerTypes.PLAYER_ERROR_OVERLAY,
                    '}',
                );
                dispatch(showOverlayDialog(errorOverlayData));
                dispatch(setScreenTaskController(ScreenTaskControllerTypes.PLAYER_ERROR_OVERLAY));
                if (errorOverlayData?.messageCode)
                    OperationsLogger.logUIErrorCode(errorOverlayData.messageCode);
            }
            Diagnostics.info(TAG, 'showErrorOverlay');
            Log.i(TAG, 'showErrorOverlay');
        }
    };

export const hideErrorOverlay = () => (dispatch: Function, getState: Function) => {
    const { isOverlayDialogActive, uiProperties } = getState().overlayDialog;
    const { overlayType } = uiProperties;
    if (
        overlayType === OverlayTypes.RECORDING ||
        overlayType === OverlayTypes.VOD_RESUME_START_OVER
    ) {
        Log.i(TAG, 'Returning as the overlay type is either Recording or Start Over.');
        return;
    }

    if (isOverlayDialogActive) {
        Diagnostics.info(TAG, 'hideErrorOverlay');
        Log.i(TAG, 'hideErrorOverlay');
        dispatch(hideOverlayDialog());
    }
};

export const onKeyBackErrorOverlay = () => (dispatch: Function) => {
    dispatch(logCancelUserActionEventForErrorOverlays());
    dispatch(hideErrorOverlay());
};

export const onKeyOkErrorOverlay = () => (dispatch: Function) => {
    dispatch(hideErrorOverlay());
    VuLogger.logUserActionEvent({
        actionName: VuLogger.UserActionEventActionName.ERROR_OVERLAY,
        action: VuLogger.UserActionEventAction.OK,
        screen: VuLogger.UserActionEventScreen.OVERLAYS,
        selection: VuLogger.UserSelection.OK,
    });
};

export const onKeyChanelUpErrorOverlay = () => (dispatch: Function) => {
    dispatch(logCancelUserActionEventForErrorOverlays());
    dispatch(hideErrorOverlay());
};

export const onKeyChannelDownErrorOverlay = () => (dispatch: Function) => {
    dispatch(hideErrorOverlay());
    dispatch(logCancelUserActionEventForErrorOverlays());
};

export const logCancelUserActionEventForErrorOverlays = () => () => {
    VuLogger.logUserActionEvent({
        actionName: VuLogger.UserActionEventActionName.ERROR_OVERLAY,
        action: VuLogger.UserActionEventAction.CANCEL,
        screen: VuLogger.UserActionEventScreen.OVERLAYS,
        selection: VuLogger.UserSelection.CANCEL,
    });
};
